<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div
    class="scroll-wrapper ui basic segment"
    [ngClass]="{ loading: pending }"
    style="padding: 0"
  >
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
    <!--Laboratory form  -->
    <div class="ui form">
      <label
        ><h3>Select Applications to Restrict Company’s Access to</h3></label
      >
      <div class="grouped fields">
        <div
          class="field"
          appMargin
          marginT="10"
          *ngFor="let app of applications"
        >
          <div>
            <sui-radio-button
              name="entity"
              [value]="app.applicationId"
              [(ngModel)]="eRadio"
            >
              <strong>{{ app.applicationName }}</strong>
            </sui-radio-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    (click)="save()"
    [disabled]="pending"
    autofocus
  >
    Downgrade
  </button>
</div>
